import React from "react";
import "./Projects.css"

const Projects=()=>{
    return(
        <div class="totalP">
            <div class="imageP">
                <div className="superP"> 
                    <div className="portfolioP"> 
                        Portfolio Website with MERN Stack
                    </div>
                    <div className="mainP"> 
                        <div className="pimage1">
                            
                        </div>
                        <div className="ptext1">  
                            <br />  Created a dynamic portfolio website with the MERN Stack which can be used for showcasing the skills and achievements of students and working professionals. Using React for a responsive frontend, MongoDB for seamless data storage, Express for robust server-side functionality, and Node.js to tie it all together, offering an impressive and interactive platform for personal and professional growth.
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="imagev">
                <div className="superv">
                    <div className="virtualtitle">
                        Virtual Reality(VR) locomotion tracking.
                    </div>
                    <div className="mainv"> 
                        <div className="pimagev">
                            
                        </div>
                        <div className="ptextv"> 
                            <br/>Designed immersive VR/MR locomotion systems using Unity, ensuring seamless user navigation within virtual environments. Implemented advanced locomotion tracking techniques to enhance user experience and immersion. Leveraged Unity's capabilities to create a dynamic and intuitive VR/MR environment, showcasing expertise in cutting-edge technologies.
                        </div> 
                    </div>
                </div>
                
                <div className="supera">
                    <div className="aug_a">
                        Augmented Reality(AR) 
                    </div>
                    <div className="maina"> 
                        <div className="pimagea">
                            
                        </div>
                        <div className="ptexta"> 
                            <br />Successfully crafted captivating augmented reality experiences using advanced effects, filters, and object tracking in Unity. This project highlights expertise in creating engaging AR/MR content, offering users a unique and interactive portal into a world of immersive visual enhancements.
                        </div> 
                    </div>
                </div>
                
                <div className="supera1">
                    <div className="aug_a1">
                        Augmented Reality(AR/MR) for movies promotion
                    </div>
                    <div className="maina1"> 
                        <div className="pimagea1">
                            
                        </div>
                        <div className="ptexta1">  
                            <br />Implemented innovative Unity solutions for dynamic movie poster tracking in augmented reality, enhancing movie promotion strategies. Developed immersive experiences that engage users with interactive elements and promotional content, fostering a deeper connection between audiences and movies. This project showcases a blend of technical proficiency and creative storytelling, utilizing AR/MR to captivate audiences in a unique and memorable way.
                        </div> 
                    </div>
                </div>
                
                <div className="superimbl">
                    <div className="imbltitle">
                        Project IMB
                    </div>
                    <div className="mainimbl"> 
                        <div className="pimageimbl">
                            
                        </div>
                        <div className="ptextimbl"> 
                            <br />Collaborated with colleague on the development of an innovative device aimed at enhancing the safety of fishermen. The project focuses on creating a reliable system that alerts fishermen upon crossing the International Maritime Boundary Line (IMBL). By combining technology and teamwork, we aimed to address maritime challenges and contribute to the well-being of the fishing community.
                        </div> 
                    </div>
                </div> 
            </div>
            
        </div> 
    )
}
export default Projects;